import { EspiraTheme as EspiraMFTheme } from '@famly/mf_theme';
import BaseTheme from './base';
const EspiraChromeColor = '#A2282F';
const EspiraTheme = {
    ...BaseTheme,
    title: 'Espira',
    chromeColor: EspiraChromeColor,
    mf: EspiraMFTheme,
};
export default EspiraTheme;
